import { Injectable, ErrorHandler } from '@angular/core';
import { LogService, LogLevel } from '../log/log.service';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class LogErrorHandler extends ErrorHandler {

  constructor(private log: LogService,
              private environment: EnvironmentConfiguration) {
    // Tell Angular to rethrow exceptions.  This ensures that operations like
    // bootstrap will fail if there is an error.
    super(true);
  }

  handleError(error) {
    // Log the error using the LogService
    this.log.error(error.toString());

    // Provide the standard Angular error handling if the log level is verbose
    if (this.environment.logServices.consoleLogSubscriber &&
      this.environment.logServices.consoleLogSubscriber.logLevel >= LogLevel.VERBOSE) {
      super.handleError(error);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/error-handler/error-handler.ts